// components/FAQManagement/FaqForm.jsx
import React, { useState, useEffect } from 'react';
import Button from '../Button';

const FaqForm = ({ faq, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    question: '',
    answer: '',
    order: 0,
    is_active: true
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (faq) {
      setFormData({
        question: faq.question || '',
        answer: faq.answer || '',
        order: faq.order ?? 0,
        is_active: faq.is_active ?? true
      });
    }
  }, [faq]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // پاک کردن خطا هنگام تغییر ورودی
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // اعتبارسنجی فیلدهای اجباری
    const newErrors = {};
    if (!formData.question.trim()) {
      newErrors.question = 'وارد کردن عنوان پرسش الزامی است';
    }
    if (!formData.answer.trim()) {
      newErrors.answer = 'وارد کردن پاسخ الزامی است';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onSubmit(formData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 animate-fadeIn">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
        {/* هدر مودال */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">
            {faq ? 'ویرایش پرسش و پاسخ' : 'افزودن پرسش جدید'}
          </h2>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* بدنه فرم */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* صورت پرسش */}
          <div>
            <label htmlFor="question" className="block text-sm font-medium text-gray-700 mb-1">
              متن پرسش *
            </label>
            <input
              type="text"
              id="question"
              name="question"
              value={formData.question}
              onChange={handleChange}
              className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                errors.question ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="مثال: نحوه محاسبه هزینه ارسال کالاها چگونه است؟"
            />
            {errors.question && <p className="mt-1 text-sm text-red-600">{errors.question}</p>}
          </div>

          {/* متن پاسخ */}
          <div>
            <label htmlFor="answer" className="block text-sm font-medium text-gray-700 mb-1">
              متن پاسخ *
            </label>
            <textarea
              id="answer"
              name="answer"
              value={formData.answer}
              onChange={handleChange}
              rows={5}
              className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                errors.answer ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="پاسخ کامل به پرسش فوق را وارد نمایید..."
            />
            {errors.answer && <p className="mt-1 text-sm text-red-600">{errors.answer}</p>}
          </div>

          <div className="grid grid-cols-2 gap-4">
            {/* اولویت/ترتیب نمایش */}
            <div>
              <label htmlFor="order" className="block text-sm font-medium text-gray-700 mb-1">
                ترتیب نمایش (اولویت)
              </label>
              <input
                type="number"
                id="order"
                name="order"
                value={formData.order}
                onChange={handleChange}
                min="0"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            {/* وضعیت فعال بودن */}
            <div className="flex items-center mt-6">
              <input
                type="checkbox"
                id="is_active"
                name="is_active"
                checked={formData.is_active}
                onChange={handleChange}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label htmlFor="is_active" className="mr-2 block text-sm text-gray-900 select-none">
                نمایش داده شود (فعال)
              </label>
            </div>
          </div>

          {/* دکمه‌های عملیات */}
          <div className="flex gap-3 pt-4 border-t border-gray-100 mt-6">
            <Button
              variant={'primary'}
              type="submit"
            >
              {faq ? 'اعمال تغییرات' : 'ثبت پرسش'}
            </Button>
            <Button
              variant={'secondary'}
              onClick={onCancel}
            >
              انصراف
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FaqForm;
